<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-08-10 12:01:35
--> 
<template>
  <div>
    <BusinessApply></BusinessApply>
  </div>
</template> 
 
<script>
import BusinessApply from './BusinessApply'
export default {
  components: {
    BusinessApply
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>